module.exports = __webpack_public_path__ + "static/media/2CAD.86f5dcad.svg";